// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__00DuZ","item":"styles_item__2ns1h"};